import { render } from "./InputArea.vue?vue&type=template&id=a523abe4&ts=true"
import script from "./InputArea.vue?vue&type=script&lang=ts"
export * from "./InputArea.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__